export const validateFileSize = ({
  file,
  onError,
  maxSize = 5,
}: {
  file: File;
  onError: (error: string) => void;
  maxSize?: number;
}) => {
  if (file.size > maxSize * 1000 * 1000) {
    onError(`アップロードしたファイルが${maxSize}MBを超えています`);
    return false;
  }

  return true;
};
